import React, { Component } from "react";
import style from "../../assets/css/modules/shared/form/password-field.css";
import { handleKeyPress } from "../../helpers/KeyPressHelper";

export class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = { showPassword: false };
    this.toggleDisplayPassword = this.toggleDisplayPassword.bind(this);
  }

  toggleDisplayPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    return (
      <React.Fragment>
        <input
          type={this.state.showPassword ? "text" : "password"}
          className={style.passwordInput + " form-control"}
          id={this.props.passwordid}
          value={this.state.password}
          onChange={this.props.changePasswordCallback}
          onBlur={this.props.blurPasswordCallback}
          onPaste={e => (this.props.preventPaste ? e.preventDefault() : true)}
          autoComplete="off"
        />
        <span
          className={"icon-eye-blue " + style.iconEyeBlue}
          data-toggle="tooltip"
          title="Show or hide password"
          tabIndex="0"
          onClick={this.toggleDisplayPassword}
          onKeyPress={e => {
            handleKeyPress(e, this.toggleDisplayPassword);
          }}
        >
          <span id="emailHelp" className="sr-only">
            Click to show or hide password.
          </span>
          <span className={style.eyeWrapper}>
            <span
              className={
                "eyeshowWrapper " +
                style.eyeshowWrapper +
                (this.state.showPassword ? " " + style.eyeshowWrapperOpen : "")
              }
            >
              <span className={style.eyeShow} />
            </span>
          </span>
        </span>
      </React.Fragment>
    );
  }
}

export default PasswordField;
